import {
    ChatFilters,
    COMMUNITY_TYPE,
    CommunityType,
} from '../interface/chats.interface';

export const getInitialFilters = (type: CommunityType): ChatFilters => {
    const baseFilters: ChatFilters = {
        date_from: null,
        date_to: null,
        limit: 10,
        offset: 0,
        page: 1,
        tag_names: [],
        name: '',
    };

    const filtersByType: Record<CommunityType, Partial<ChatFilters>> = {
        [COMMUNITY_TYPE.MANAGE]: { is_chat_bot_source: true },
        [COMMUNITY_TYPE.MONITORING]: { is_user_bot_source: true },
    };

    return {
        ...baseFilters,
        ...filtersByType[type],
    };
};
